module.exports = __webpack_public_path__ + "static/media/move-tool-white.9e36aad8.svg";